<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.lotteryType' clearable
                      :placeholder="$t('彩种') " style='width:120px'>

                <Option :key="key" :value="value['lotteryType']"
                        v-for="(value, key) in lotteryParams"> {{ value['lotteryName'] }}
                </Option>
              </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.number' :placeholder="$t('当前期号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.pictureTypeId' :placeholder="$t('图类ID') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.pictureName' :placeholder="$t('图名') "></Input>
            </FormItem>

            <Select clearable v-model='searchConf.isTuijian' clearable
                    :placeholder="$t('是否推荐') " style='width:120px'>

              <Option :value="0" >{{ $t('不推荐') }}</Option>
              <Option :value="1" >{{ $t('推荐') }}</Option>
            </Select>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->

    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
                    <div class='margin-bottom-15'>
                      <Button type='primary' @click='preAdd' icon='md-add'>{{
                          $t('add_button')
                        }}
                      </Button>
                    </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='彩种' prop='title'>
        <Select clearable v-model='windowAddItem.lotteryType' clearable
                :placeholder="$t('彩种') " style='width:120px'>

          <Option :key="key" :value="value['lotteryType']"
                  v-for="(value, key) in lotteryParams"> {{ value['lotteryName'] }}
          </Option>
        </Select>
        </FormItem>
        <FormItem label='图名称' prop='pictureName'>
          <Input clearable v-model='windowAddItem.pictureName' :placeholder="$t('请输入图名称')"></Input>
        </FormItem>
        <FormItem label="图编码" >
          <Input :disabled="windowAddItem.id>0" clearable v-model='windowAddItem.pictureTypeId' :placeholder="$t('请输入图编码(输入个不存在的数字编号就行)')"></Input>
        </FormItem>


        <FormItem label="是否彩色">
          <i-switch v-model="windowAddItem.color"
                    :true-value=1 :false-value=2 true-color="#13ce66"/>
        </FormItem>

        <FormItem label='当前期号' prop='number'>
          <Input clearable v-model='windowAddItem.number' :placeholder="$t('请输入期号不含年份')"></Input>
        </FormItem>

        <FormItem label='高度' prop='height'>
          <Input clearable v-model='windowAddItem.height' :placeholder="$t('请输入高度')"></Input>
        </FormItem>
        <FormItem label='宽度' prop='width'>
          <Input clearable v-model='windowAddItem.width' :placeholder="$t('请输入宽度')"></Input>
        </FormItem>

<!--        <FormItem label="图片地址说明">-->
<!--          <div>本地图片由 图片域名/images/self/year/issue/pictureTypeId.png</div>-->
<!--        </FormItem>-->
<!--        <FormItem label="缩略图地址">-->
<!--          <div>本地图片由 图片域名/images/self/m/year/issue/pictureTypeId.png</div>-->
<!--        </FormItem>-->
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
    <!-- windowAddEdit2 -->
    <Modal v-model="windowAdd2.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAdd2Cancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem2.id ? $t('填上期号,上传图片后就可以关闭') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm2" :rules="windowAddValidate2" :model="windowAddItem2" :label-width="80"
            label-position="left">
        <FormItem label='图片期号(含年)' prop='number'>
          <Input clearable v-model='windowAddItem2.yearIssue' :placeholder="$t('请输入图片期号含年份  如：2024001')"></Input>
        </FormItem>

        <FormItem label="图片" prop="selfPic">

          <FormItem label='图片(链接)' prop='selfPic'>
            <Input clearable v-model='windowAddItem2.selfPic' :placeholder="$t('请输入图片的链接地址')"></Input>
          </FormItem>
          <div class="demo-upload-list" v-if="windowAddItem2.selfPic">
            <img :src="windowAddItem2.selfPic" style="max-width: 200px;max-height: 200px">
            <div class="demo-upload-list-cover">
              <Icon type="ios-trash-outline" @click.native="handleImgRemove('selfPic')"></Icon>
            </div>
          </div>
          <input v-if="windowAddItem2.selfPic" v-model="windowAddItem2.selfPic" type="hidden" name="image">
          <Upload type="drag" :action="uploadUrl" :headers="uploadHeader" :data="{tuku_id:windowAddItem2.id,yearIssue:windowAddItem2.yearIssue}" v-if="!windowAddItem2.selfPic"
                  :format="['jpg','jpeg','png','gif']" :max-size="5120"
                  :on-success="v=>{handleImgSuccess(v,'selfPic')}"
                  :on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
                  style="display: inline-block;width:58px">
            <div style="width: 58px;height:58px;line-height: 58px">
              <Icon type="md-camera" size="20"></Icon>
            </div>
          </Upload>

        </FormItem>

                <FormItem label="大图地址">
                  <div>{{windowAddItem2.selfPic}}</div>
                </FormItem>
                <FormItem label="缩略图地址">
                  <div>{{windowAddItem2.selfSmallPic}}</div>
                </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAdd2Cancel()" class="margin-right-10">{{ $t('关闭') }}</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

import {
  baseUrl
} from '@/libs/api.request'
import {
  getToken
} from '@/libs/util'

export default {
  name: 'interface_list',
  data() {
    return {
      uploadHeader: {
        'Authorization': "bearer " + getToken()
      },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: 'ID',
        key: 'id',
        width: 45,
        align: 'center'
      },{
        title: '图类ID',
        key: 'pictureTypeId',
        width: 45,
        align: 'center'
      },  {
        title: '彩种',
        key: 'lotteryName',
        width: 65,
        align: 'center'
      }, {
        title: this.$t('名称'),
        key: 'pictureName',
        width: 185,
        align: 'center'
      },{
        title: '常规排序(数字大的优先)',
        sortable: true,
        key: 'showOrder',
        align: 'center',
        hidden:1,
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.showOrder,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('tuku/TukuAll', {op:'save',id:params.row.id,showOrder:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },{
        title: '当前期号',
        key: 'number',
        width: 35,
        align: 'center'
      },{
        title: '大图(采集)',
        key: 'bigPictureUrl',
        width: 125,
        align: 'center'
      },{
        title: '大图(自己源)',
        key: 'selfBigPictureUrl',
        width: 125,
        align: 'center'
      },  {
        title: '是否推荐',
        sortable: true,
        align: 'center',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isTuijian,
            },
            on: {
              'on-change': function (status) {
                customPost('tuku/TukuAll', {op: 'show', id: params.row.id, isTuijian: status}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "推荐"),
            h('span', {
              slot: 'close'
            }, "不推荐")
          ])
        }
      },{
        title: '推荐排序(数字大的优先)',
        sortable: true,
        key: 'tuijianOrder',
        align: 'center',
        hidden:1,
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.tuijianOrder,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('tuku/TukuAll', {op:'save',id:params.row.id,tuijianOrder:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },{
        title: '是否图书(非图书类为0)',
        sortable: true,
        key: 'isBookOrder',
        align: 'center',
        hidden:1,
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.isBookOrder,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('tuku/TukuAll', {op:'save',id:params.row.id,isBookOrder:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },{
        title: '是否显示',
        sortable: true,
        align: 'center',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShow,
            },
            on: {
              'on-change': function (status) {
                customPost('tuku/TukuAll', {op: 'show', id: params.row.id, isShow: status}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显示")
          ])
        }
      },{
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              disabled: params.row.isSelf != 1,
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                Object.assign(vm.windowAddItem, params.row) //浅复制数据params.row 给 vm.windowAddItem
                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑')),h('Button', {
            props: {
              type: 'warning',
              disabled: params.row.isSelf != 1,
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                Object.assign(vm.windowAddItem2, params.row) //浅复制数据params.row 给 vm.windowAddItem
                vm.windowAdd2.show = true
              }
            }
          }, this.$t('传图')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('tuku/TukuAll', {op: 'del', id: params.row.id}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting,
                disabled: params.row.isSelf != 1,
              }
            }, this.$t('删除'))
          ])])
        }
      }],
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/uploadForPicture',
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddItemTemp: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },
      //----------------
      //弹窗--------------
      windowAdd2: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem2: { //弹窗数据绑定
        id: 0
      },
      windowAddItemTemp2: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate2: {//窗口校验规则
      },
      //----------------
      positionParams: {},
      lotteryParams: {},
      isShowChangeType:false
    }
  },
  created() {
    let vm = this

    customPost('tuku/TukuAll', {op: 'getLotteryTypes'}).then(response => {
      vm.lotteryParams = response.data.data;
      vm.getList();
    })


  },
  mounted() {

  },
  methods: {
    changePosition(e){
      if(e==4){
        this.isShowChangeType=true
      }else{
        this.isShowChangeType=false
      }
      console.log( this.windowAddItem.position)
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page = vm.tableShow.currentPage
      vm.searchConf.size = vm.tableShow.pageSize
      customPost('tuku/TukuAll', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id = 0;
      vm.windowAddItem.lotteryType = 1;
      vm.windowAddItem.pictureName = '';
      vm.windowAddItem.pictureTypeId = '';
      vm.windowAddItem.color = 1;
      vm.windowAddItem.number=''
      vm.windowAddItem.height=''
      vm.windowAddItem.width=''
      vm.windowAddItem.isShow = 1;
      vm.windowAdd.show = true
      this.isShowChangeType=false
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          Object.assign(vm.windowAddItemTemp, vm.windowAddItem) //浅复制数据params.row 给 vm.windowAddItemTemp
          vm.windowAddItemTemp.op = 'create';
          customPost('tuku/TukuAll', vm.windowAddItemTemp).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
    handleImgFormatError(file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove(key) {
      this.windowAddItem2[key] = ''
    },
    handleImgSuccess(response, key) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        if (response.data.fileUrl.startsWith('http')) {
          this.windowAddItem2[key] = response.data.fileUrl
          this.windowAddItemTemp2[key] = response.data.fileUrl
          this.windowAddItem2['selfSmallPic']= response.data.showSmallUrl
        } else {
          this.windowAddItem2[key] = response.data.showUrl
          this.windowAddItemTemp2[key] = response.data.showUrl
          this.windowAddItem2['selfSmallPic']= response.data.showSmallUrl
          console.log(this.windowAddItem.js)
          this.$forceUpdate();
        }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },

    windowAdd2Cancel(data) {
      if (!data) {
        this.windowAddItem2.id = 0
        this.windowAddItem2['selfSmallPic']='';
        this.windowAddItem2['selfPic']='';
        this.$refs['windowAddForm2'].resetFields()
        this.windowAdd2.show = false
        this.windowAdd2.loading = false
        this.windowAdd2.index = 0
      }
    }, windowAdd2Submit() {
      let vm = this
      vm.$refs['windowAddForm2'].validate((valid) => {
        if (valid) {
          vm.windowAdd2.loading = true
          Object.assign(vm.windowAddItemTemp2, vm.windowAddItem2) //浅复制数据params.row 给 vm.windowAddItemTemp
          vm.windowAddItemTemp2.op = 'create';
          customPost('tuku/TukuAll', vm.windowAddItemTemp2).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAdd2Cancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
